/**
 * 自定义警告错误，用于显示警告信息
 */
export class ToastWarning extends Error {
    constructor(message) {
        super(message);
        this.type = 'ToastWarning';
    }
}
/**
 * 判断是否为自定义警告错误
 * @param error 错误对象
 * @returns 是否为自定义警告错误
 */
export function isToastWarning(error) {
    return error && error.type === 'ToastWarning';
}
